module.exports = __webpack_public_path__ + "img/3000.f3f8379a.png";